import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["indicator"];

  connect(){
    this.boundHandleBeforeFetchRequest = this.handleBeforeFetchRequest.bind(this)
    this.boundHandleBeforeFetchResponse = this.handleBeforeFetchResponse.bind(this)
    this.element.addEventListener("turbo:before-fetch-request", this.boundHandleBeforeFetchRequest)
    this.element.addEventListener("turbo:before-fetch-response",this.boundHandleBeforeFetchResponse)
  }

  disconnect(){
    this.element.removeEventListener("turbo:before-fetch-request", this.boundHandleBeforeFetchRequest)
    this.element.removeEventListener("turbo:before-fetch-response",this.boundHandleBeforeFetchResponse)
  }

  handleBeforeFetchRequest(e) {
    this.displayLoading();
  }

  handleBeforeFetchResponse(e) {
    this.hideLoading();
  }

  displayLoading() {
    this.indicatorTarget.hidden = false;
  }

  hideLoading() {
    this.indicatorTarget.hidden = true;
  }
}
